import React, { Component, PureComponent } from 'react'
import { Router, Route, Redirect, Switch } from 'react-router'

import Login from './auth/login'
import Logout from './auth/logout'

// Load components
import AppWrapper from './common/wrapper'
import NotFound from './common/notfound'

import ProjectRoot from './project/root'
import ProjectView from './project/views/view'

import UserRoot from './user/root'
import UserRoleRoot from './userRole/root'
import OrganizationRoot from './organization/root'
import ProductRoot from './product/root'
import TaskTypeRoot from './taskType/root'
import TaskRoot from './task/root'
import EventRoot from './event/root'
import InvoiceRoot from './invoice/root'
import OrderRoot from './order/root'
import ContactRoot from './contact/root'
import MessageTemplateRoot from './messageTemplate/root'
import FileRoot from './file/root'
import ArticleRoot from './article/root'
import InterviewRoot from './interview/root'
import CoordinationView from './coordination'

export default (
  <Switch>
    <Route path="/login" component={Login} />
    <Route path="/">
      <AppWrapper>
        <Switch>
          <Route path="/order" component={OrderRoot} />
          <Route path="/project/:project_id" component={ProjectView} />
          <Route path="/project" component={ProjectRoot} />
          <Route path="/interview" component={InterviewRoot} />
          <Route path="/organization" component={OrganizationRoot} />
          <Route path="/task" component={TaskRoot} />
          <Route path="/contact" component={ContactRoot} />
          <Route path="/file" component={FileRoot} />
          <Route path="/article" component={ArticleRoot} />
          <Route path="/coordination" component={CoordinationView} />
          <Route path="/settings/user" component={UserRoot} />
          <Route path="/settings/user_role" component={UserRoleRoot} />
          <Route path="/settings/product" component={ProductRoot} />
          <Route path="/settings/tasktype" component={TaskTypeRoot} />
          <Route path="/settings/event" component={EventRoot} />
          <Route path="/settings/invoice" component={InvoiceRoot} />
          <Route path="/settings/messagetemplates" component={MessageTemplateRoot} />
          <Route path="/logout" component={Logout} />
          <Redirect path="/" to="/organization" />
          <Route path="*" component={NotFound} />
        </Switch>
      </AppWrapper>
    </Route>
  </Switch>
)
